module.exports = __webpack_public_path__ + "0886a36624c50667e0195ff7023f4002.gif";